var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentCopyOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6C4 4.73684 4.73684 4 6 4H14C15.2632 4 16 4.73684 16 6V14C16 15.2632 15.2632 16 14 16H6C4.73684 16 4 15.2632 4 14V6ZM2 6V14C2 16.2456 3.75439 18 6 18H14C16.2456 18 18 16.2456 18 14V6C18 3.75439 16.2456 2 14 2H6C3.75439 2 2 3.75439 2 6ZM17 9.05263H18C19.2632 9.05263 20 9.78947 20 11.0526V18C20 19.2632 19.2632 20 18 20H11.0526C9.78947 20 9.05263 19.2632 9.05263 18V17C9.05263 16.4561 8.59649 16 8.05263 16C7.50877 16 7.05263 16.4561 7.05263 17V18C7.05263 20.2456 8.80702 22 11.0526 22H18C20.2456 22 22 20.2456 22 18V11.0526C22 8.80702 20.2456 7.05263 18 7.05263H17C16.4561 7.05263 16 7.50877 16 8.05263C16 8.59649 16.4561 9.05263 17 9.05263Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopyOutlined);
export default __webpack_public_path__ + "static/media/content_copy_outlined.8abe4805.svg";
export { ForwardRef as ReactComponent };